export default [{
  iconName: 'ticket.png',
  selectIconName: 'ticket-1.png',
  name: '售票',
  path: '/index',
  role: ['v1.window.sellTickets']
}, {
  iconName: 'tp.png',
  selectIconName: 'tp-1.png',
  name: '退票',
  path: '/refundTicket',
  role: ['v1.window.order.refund.ticket', 'v1.window.order.refund.yearCard']
}, {
  iconName: 'user.png',
  selectIconName: 'user-1.png',
  name: '会员',
  path: '/detailUser',
  role: ['v1.window.yearCard']
}, {
  iconName: 'order.png',
  selectIconName: 'order-1.png',
  name: '订单',
  path: '/orderList',
  role: ['v1.window.order.ticket', 'v1.window.order.yearCard']
},{
  iconName: 'jb.png',
  selectIconName: 'jb-1.png',
  name: '交班',
  path: '/shift',
  role: []
},{
  iconName: 'bb.png',
  selectIconName: 'bb-1.png',
  name: '报表',
  path: '/statement',
  role: ['v1.window.statement.ticket', 'v1.window.statement.yearCard','v1.window.statement.income']
}
]
